import React from "react";
import { useIntl } from "../../utils/intl";
import { FadeUp } from "../Molecules/FadeUp";
export default function ContactBlock(param) {
    var name = param.name, email = param.email, phone = param.phone, jobTitle = param.jobTitle, intro = param.intro;
    var intl = useIntl();
    return /*#__PURE__*/ React.createElement(FadeUp, {
        yGap: 50
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center max-w-[100%] w-[315px] h-[273px] md:w-[527px] md:h-[457px] xl:w-[694px] xl:h-[601px] mx-auto block relative z-0 my-[90px] lg:my-20"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-[url('/images/YellowTriangleDownContact.svg')] bg-no-repeat bg-center h-full bg-contain absolute w-full z-0 top-0"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "relative z-10"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "pt-8 md:pt-10 xl:pt-12 small mt-0 mb-3 md:mb-4 xl:mb-6 font-medium font-lexend"
    }, intro ? intro : intl.formatMessage({
        defaultMessage: "Get to know",
        id: "w6nr7h"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "block h3 my-0"
    }, name), /*#__PURE__*/ React.createElement("div", {
        className: "block mb-5 tiny font-medium"
    }, jobTitle), /*#__PURE__*/ React.createElement("a", {
        href: "mailto:".concat(email),
        className: "block text-turquoise-500 mb-5 hover:text-purple duration-300 font-normal"
    }, email), /*#__PURE__*/ React.createElement("a", {
        href: "tel:".concat(phone),
        className: "block text-turquoise-500 hover:text-purple duration-300 font-normal uppercase"
    }, phone))));
}
